module.exports = __webpack_public_path__ + "static/media/goSchoolZone_english.6ef59ad2.png";